import React from 'react';
import './downloadapp.css';

const Section4 = () => {
  return (
    <section className="section4">
      
      <div className='section4-download'>
        <div className='section4-download-text1'>
        <p>Download the app</p>
        </div>
        {/*<div className='section4-download1'>
          <div className='section4-stars'>
            <ion-icon name="sparkles-outline"></ion-icon>
          </div>
          <h6>1,5M+ downloads</h6>
        </div>*/}
        <div className='section4-download-text2'>
        <p>Download the app by scanning the QR-code with your cellphone</p>
        </div>
        <div className='section4-download2'>
          <div className='section4-qr-scan'>
            <img src='../images/Qr-Code.png' alt='App download QR code' /> 
          </div>
          <div className='section4-downloadstores'>
            <button className='downloadstore1'>
              <div className='appstore'>
                <ion-icon name="logo-apple-appstore"></ion-icon>
              </div>
              <h7>App Store</h7>
            </button>
             <button className='downloadstore2'>
             <div className='googleplay'>
                <ion-icon name="logo-google-playstore"></ion-icon> 
              </div>
               <h7>Google Play</h7>
            </button> 
              
          </div>
        </div>
      </div>

      <div className='section4-iphone'>
        <img src='../images/Nyiphone.png' alt='Penny app on phone' /> 
      </div>
    </section>
  );
};

export default Section4;
